import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react'
import { type BaseQueryFnType, type IUser, type ICreateUserQuery, type IEditUserQuery, type IDeleteUserQuery } from './types'
import { USERS_END_POINT } from './endpoints'
import { HEADERS_TITLE } from './constants'

const BASE_URL = process.env.REACT_APP_API_URL as string

export const usersApi = createApi({
  reducerPath: 'usersApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      headers.set('Accept', 'application/json')
      return headers
    }
  }) as BaseQueryFnType,
  endpoints: (builder) => ({
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    getUsers: builder.mutation<IUser[], void>({
      query () {
        return {
          url: USERS_END_POINT.USERS,
          method: 'GET',
          credentials: 'include'
        }
      }
    }),
    postUser: builder.mutation<[], ICreateUserQuery>({
      query: ({ email, firstName, secondName, photoUrl, token }) => {
        return {
          url: USERS_END_POINT.USERS,
          method: 'POST',
          body: { email, firstName, secondName, photoUrl },
          credentials: 'include',
          headers: {
            [HEADERS_TITLE.XSRF]: token
          }
        }
      }
    }),
    patchUser: builder.mutation<[], IEditUserQuery>({
      query: ({ email, firstName, secondName, photoUrl, id, token }) => {
        return {
          url: USERS_END_POINT.USER_DETAILS(id),
          method: 'PATCH',
          body: { email, firstName, secondName, photoUrl },
          credentials: 'include',
          headers: {
            [HEADERS_TITLE.XSRF]: token
          }
        }
      }
    }),
    deleteUser: builder.mutation<[], IDeleteUserQuery>({
      query: ({ id, token }) => {
        return {
          url: USERS_END_POINT.USER_DETAILS(id),
          method: 'DELETE',
          credentials: 'include',
          headers: {
            [HEADERS_TITLE.XSRF]: token
          }
        }
      }
    })
  })
})

export const {
  useGetUsersMutation,
  usePostUserMutation,
  usePatchUserMutation,
  useDeleteUserMutation
} = usersApi
